export default {};
export const API_URL = "https://checkout.rch.io/v2.18/";
export const CURRENCY_URL = "https://fe-support.rch.io/";
export const STASH_URL = "https://stash.rch.io/";
export const SIGN_URL = "https://fe-support.rch.io/";
export const CLIENTS_URL = "/clients/";
